import { all } from '../utils/dom';

export function init() {
	let elements = all('.js-faux-link');

	elements.forEach(element => {
		element.addEventListener('mouseout', () => toggleHover(element, false));
		element.addEventListener('mouseenter', () => toggleHover(element, true));
	});
}

function toggleHover(element, force) {
	if (!element) {
		return;
	}

	element.classList.toggle('hover', force);
}
